import { render, staticRenderFns } from "./ApontamentoOcorrenciaModal.vue?vue&type=template&id=52a20f4e"
import script from "./ApontamentoOcorrenciaModal.vue?vue&type=script&lang=js"
export * from "./ApontamentoOcorrenciaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports